interface FunnelModalContentProps {
  html: string;
}

const FunnelModalContent: React.FC<FunnelModalContentProps> = ({ html }) => {
  return (
    <div
      data-testid="funnel-modal-content"
      className="prose marker:text-black"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default FunnelModalContent;
